
import { Interaction } from "./interaction.abstract";



export type StatusQuestion = 'open' | 'closed' | 'ignored' | 'actionRequired';

export type TypeQuestion = 'any' | 'expensas';

export const QuestionSteps = {
    //textos unificados (AF340): el estado dice cómo está la entrada; el botón, qué hacer
    open:{label:'Con AdminAI', step: 1, variant:'waiting'},
    closed:{label:'Resuelto', step: 1, variant:'success'},
    ignored:{label:'Rechazado', step: 1, variant:'error'},
    actionRequired:{label:'Por atender', step: 1, variant:'action'}
}

export interface Question extends Interaction {
  
  // texto y color que ve el usuario: el mapa *Steps de este archivo (vocabulario de AF340)
  status: StatusQuestion; 
  resume: string; // descripción corta del agente (es casi un subtitulo, por ejemplo “problema de humedad”)
  closedBy: 'agent' | 'human'; //por defecto es cerrado por el agente, pero si el consorcista cierra la consulta, se marca como cerrado por humano. Esto es para tener un mejor control de las consultas y saber si el agente esta cerrando las consultas o no.
  type: TypeQuestion; // tipo de consulta, por defecto es any, pero puede ser expenses si es una consulta relacionada con gastos o expensas. Esto es para poder filtrar las consultas por tipo y poder hacer un mejor seguimiento de las mismas.
}

export interface newQuestion extends Omit<Question, 'nro' |'uid' | 'createdAt' | 'status' | 'id'|'consorcioId' | 'consorcioName' | 'consorcista' | 'consorcistaId'>{};

export const SUBCOLLECTION = 'questions';
export type Model = Question;